import axios from 'axios'
import baseUrl from '../config'

export const fetchAudio = (url, context) =>
  fetch(url)
    .then((response) => response.arrayBuffer())
    .then((arrayBuffer) => context.decodeAudioData(arrayBuffer))
    .then((audioBuffer) => ({
      playButtonDisabled: false,
      audioBuffer: audioBuffer,
      context,
    }))
    .catch(() => false)

export const saveNotes = (url, data) =>
  axios
    .put(baseUrl + url, data)
    .then(() => true)
    .catch(() => false)
